import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  Chip, Dialog, LinearProgress, Stack,
} from '@mui/material';
import {
  IDispatchProps, IProps, IStateProps,
} from './interfaces';
import { deleteSelectedAssets, toggleDeleteAssets } from '../../../state/deleteAssets';
import {
  ActionContainer,
  DialogActionsOverride,
  DialogContentContainer,
  DialogHeader,
  DialogHeaderTitle,
  SelectedAssetsContainer,
  SelectedAssetsInfoText,
  SelectedAssetsItemList,
  SelectedAssetText,
  SelectedDeleteAssetText,
} from './styles';
import { IAppState } from '../../../state/reducers';
import { VaultButton } from '../../Shared';
import { VAULT_MEDIA_TYPE, VAULT_VIDEO_TYPE } from '../../../constants';
import { StreamStatus } from '../../../enums';
import { ProgressContainer } from '../../Shared/JobList/styles';

const currentlyLiveStatuses = [StreamStatus.Initializing, StreamStatus.Processing, StreamStatus.Live];

interface IState {
  isDeleting: boolean;
}
class DeleteAssetsDialog extends PureComponent<IProps, IState> {
  private static readonly deleteText = 'Delete';
  private static readonly deleteCancel = 'Cancel';

  constructor(props: IProps) {
    super(props);
    this.state = {
      isDeleting: false,
    };
  }

  closeDialogBox = (e: React.MouseEvent<HTMLButtonElement>) => {
    const { toggleDelete } = this.props;
    toggleDelete(false, []);
  };

  handleDelete = async (e: React.MouseEvent<HTMLButtonElement>) => {
    const {
      selectedAssets,
      deleteAssets,
      updateSelectedAssets,
    } = this.props;
    this.setState({ isDeleting: true });
    const selectedMongoIDs = { ids: selectedAssets.map((m) => m._id) };
    deleteAssets(selectedMongoIDs, true, () => {
      this.setState({ isDeleting: false });
    });
    if (updateSelectedAssets) {
      updateSelectedAssets([]);
    }
  };

  render() {
    const { selectedAssets, isDeleteButtonClicked } = this.props;

    return (
      <Dialog open={isDeleteButtonClicked} fullWidth maxWidth="md">
        <DialogHeader>
          <DialogHeaderTitle
            data-auto="DeleteAssetsModal"
          >
            {DeleteAssetsDialog.deleteText}
          </DialogHeaderTitle>
        </DialogHeader>
        <ProgressContainer>
          {(this.state.isDeleting) && <LinearProgress />}
        </ProgressContainer>
        <DialogContentContainer>
          <SelectedAssetsContainer>
            <SelectedAssetsInfoText>Deleting {selectedAssets.length} Items</SelectedAssetsInfoText>
            <SelectedAssetsItemList>
              {selectedAssets.map(((s: any) => {
                if (s._source.type === VAULT_MEDIA_TYPE.liveVideo && s._source.videoType === VAULT_VIDEO_TYPE.LiveStream && s._source.streamStatus && currentlyLiveStatuses.includes(s._source.streamStatus)) {
                  return (
                    <Stack direction="row" spacing={1} style={{ marginBottom: '5px' }}>
                      <SelectedDeleteAssetText key={s._source.title}>{s._source.title}</SelectedDeleteAssetText>
                      <Chip label="Active Live Event" color="error" />
                    </Stack>
                  );
                }
                return (<SelectedAssetText style={{ marginBottom: '5px' }} key={s._source.title}>{s._source.title}</SelectedAssetText>);
              }))}
            </SelectedAssetsItemList>
          </SelectedAssetsContainer>
        </DialogContentContainer>
        <DialogActionsOverride disableSpacing>
          <ActionContainer>
            <VaultButton
              id={DeleteAssetsDialog.deleteCancel}
              variant="plainOnPaper"
              onClick={this.closeDialogBox}
              disabled={this.state.isDeleting}
            >
              {DeleteAssetsDialog.deleteCancel}
            </VaultButton>
            <VaultButton
              id={DeleteAssetsDialog.deleteText}
              disabled={selectedAssets.length === 0 || this.state.isDeleting}
              variant="primaryOnWhite"
              onClick={this.handleDelete}
            >
              {DeleteAssetsDialog.deleteText}
            </VaultButton>
          </ActionContainer>
        </DialogActionsOverride>
      </Dialog>
    );
  }
}
const mapStateToProps = (state: IAppState): IStateProps => ({
  isDeleteButtonClicked: state.deleteAssets.isDeleteButtonClicked,
  selectedAssets: state.deleteAssets.selectedAssets,
  areAssetsDeleted: state.deleteAssets.areAssetsDeleted,
});

const mapDispatchToProps: IDispatchProps = {
  deleteAssets: deleteSelectedAssets,
  toggleDelete: toggleDeleteAssets,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAssetsDialog);
